import { SEOHead } from "@/components/SEOHead";

const Double = () => {
  return (
    <>
      <SEOHead
        title="Double | Son's Guadalupe"
        description="Extra content page"
        noIndex={true}
      />
      <div className="min-h-screen bg-background pt-20">
        {/* Rio Cibolo Banner */}
        <a
          href="https://sonsriocibolo.com/book-now"
          target="_blank"
          rel="noopener noreferrer"
          className="block bg-coral-orange text-white text-center py-2 px-4 text-sm md:text-base font-medium hover:bg-coral-orange/90"
        >
          🌊 Availability Today & Tonight at Son's Rio Cibolo — <span className="font-bold">Book Now</span> — Use Promo Code: <span className="font-bold">SONS20</span> for 20% OFF 🎉
        </a>

        {/* Son's River Ranch Weekend Banner */}
        <a
          href="https://sonsriverranch.com/book-now"
          target="_blank"
          rel="noopener noreferrer"
          className="block bg-coral-orange text-white text-center py-2 px-4 text-sm md:text-base font-medium hover:bg-coral-orange/90 mt-4"
        >
          🏕️🌊 $49 Glamping Cabins Friday & $49 Cabanas ALL WEEKEND at Son's River Ranch — <span className="font-bold">BOOK NOW!</span> 🎉☀️
        </a>
      </div>
    </>
  );
};

export default Double;
